import { render } from "./FluidsTestTab.vue?vue&type=template&id=83029ec0"
import script from "./FluidsTestTab.vue?vue&type=script&lang=js"
export * from "./FluidsTestTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__